import ReactGA from "react-ga4";

const fireLoginEvent = (name) => ReactGA.event("login", { method: name });
const fireSearchEvent = (term) => ReactGA.event("search", { search_term: term });
const fireAddToCartEvent = (value, items) => ReactGA.event("add_to_cart", {
    currency: "BAM",
    value: value,
    items: items
});

const fireRegisterAccountEvent = (action, label) => ReactGA.event({
    category: "Registracija",
    action: action,
    label: label
});

const fireSimpleOrderEvent = (action, label) => ReactGA.event({
    category: "Jednostavna kupovina",
    action: action,
    label: label
});

const gaEvents = {
    loginEvent: (name) => fireLoginEvent(name),
    registerAccountEvent: (action, label) => fireRegisterAccountEvent(action, label),
    searchEvent: (term) => fireSearchEvent(term),
    addToCartEvent: (value, items) => fireAddToCartEvent(value, items),
    simpleOrderEvent: (action, label) => fireSimpleOrderEvent(action, label)
};


export { gaEvents };